import withSSRModel from "hoc-lib/ssrModelMapper"
import { connect } from "react-redux"
import { FacilityDetails as FacilityDetailsComponent } from "./FacilityDetails"

export const mapStateToProps = (state) => ({
  siteLanguage: state.siteLanguage,
  facilityAlerts: state.facilityLocator?.alerts,
})

const WrappedComponent = withSSRModel(
  connect(mapStateToProps)(FacilityDetailsComponent),
)

// Component has to be mapped by the consumer
// Config has to be imported from constants-lib and passed to the MapTo function by the consumer
export default WrappedComponent
